module.exports = __webpack_public_path__ + "a4cf1f4f2c7aa3a8f12c48310a852616.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/medieval-tower-empty.png
// module id = 2840
// module chunks = 0